export default __webpack_public_path__ + "static/media/messageIconWhite.dcba040a.svg";